// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"112887ae","469":"0563380a","833":"6b4f2f64"}[chunkId] + ".chunk.js";
};